<template>
	<div class="page">
		<div class="pagediv">
			<div>共{{total}}条</div>
			<el-select v-model="selectval" placeholder="请选择" @change="selectChange">
				<el-option v-for="item in pageSizes" :key="item" :label="item+'条/页'" :value="item">
				</el-option>
			</el-select>
			<div :class="enter == 1 ? 'sbtn not':'sbtn'" @click="turnpage(1)">
				<svg-icon icon-class="pagezuo" style="font-size: 8px;"></svg-icon>
			</div>
			<div :class="enter == 1 ? 'sbtn not':'sbtn'" @click="turnpage(2)">
				<svg-icon icon-class="jiantouzuo" style="font-size: 8px;"></svg-icon>
			</div>
			<div class="jump">
				<input type="number" v-model="enter" @blur="gbys"/>/{{number}}
			</div>
			<div :class="enter >= number ? 'sbtn not':'sbtn'" @click="turnpage(3)">
				<svg-icon icon-class="jiantouyou" style="font-size: 8px;"></svg-icon>
			</div>
			<div :class="enter >= number ? 'sbtn not':'sbtn'" @click="turnpage(4)">
				<svg-icon icon-class="pageyou" style="font-size: 8px;"></svg-icon>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				enter: 1,
				pageSizes: [10,20,50,100],
				selectval: 10,
			}
		},
		props: {
			pagesize: "",
			total: "",
			page: "",
		},
		
		watch:{
			pagesize(val,old){
				if(this.selectval != val){
					this.selectval = val;	
				}
			},
			
			page(val,old){
				if(this.enter != val){
					this.enter = val;	
				}
			}
		},
		
		computed: {
			number: function() {
				return Math.ceil(this.total / this.pagesize)
			}
		},
		methods: {
			selectChange(val){
				this.$emit('update:pagesize', val)
				this.$emit("enter", 1);
			},
			
			gbys(val){
				if(this.enter > this.number){
					this.enter = this.number;
				}
				if(this.enter <= 0 || !this.enter){
					this.enter = 1;
				}
				this.$emit("enter", this.enter);
			},
			
			turnpage(num){
				if(num == 1){
					this.enter = 1;
				}
				if(num == 2){
					if(this.enter <= 1){
						this.enter = 1;
					}else{
						this.enter--;
					}
				}
				if(num == 3){
					
					if(this.enter >= this.number){
						this.enter = this.number;
					}else{
						this.enter++;
					}
				}
				if(num == 4){
					this.enter = this.number;
				}
				
				this.$emit("enter", this.enter);
			}
		}
	}
</script>

<style scoped lang="less">
	.pagediv {
		width: 100%;
		height: 58px;
		display: flex;
		align-items: center;
		// padding-left: 15px;
		font-size: 12px;
		color: #545566;
		margin-left: 12px;
		.jump {
			font-size: 12px;
			color: #8a8a9a;
			display: flex;
			margin-left: 5px;
			align-items: center;
			input {
				width: 34px;
				height: 20px;
				border: 1px solid #ebebf3;
				border-radius: 6px;
				text-align: center;
				margin: 0 4px;
				color: #545566;
			}
			input:focus {
				border: 1px solid #6669e3;
			}
			button {
				width: 44px;
				height: 28px;
				line-height: 26px;
				border: 1px solid #6669e3;
				background-color: #fff;
				color: #6669e3;
				text-align: center;
				border-radius: 4px;
				margin-left: 18px;
				font-size: 12px;
				cursor: pointer;
			}
			button:hover {
				background-color: #8285ff;
				border: 1px solid #8285ff;
				color: #fff;
			}
			button:active {
				background-color: #5658c5;
				border: 1px solid #5658c5;
				color: #fff;
			}
		}
		
		.el-select{
			width: 90px;
			height: 22px;
			margin-left: 12px;
			margin-right: 20px;
		}
		
		/deep/ .el-input__inner{
			height: 22px;
			line-height: 22px;
			padding: 0 10px;
			font-size: 12px;
		}
		
		/deep/ .el-input__icon{
			line-height: 22px;
			right: 1px;
		}
		
		/deep/ .el-input--suffix .el-input__inner {
			padding-right: 20px;
		}
		/deep/ .el-select-dropdown__item.selected {
          color: #6669e3;
          font-weight: 700;
		  
        }
		/deep/ .el-select-dropdown__item {
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            padding: 0 16px;
       }
		
		.sbtn{
			width: 16px;
			height: 16px;
			border-radius: 4px;
			margin-left: 6px;
			cursor: pointer;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		
		.sbtn:hover{
			background: #F7F8FC;
		}
		
		.not{
			cursor: not-allowed;
		}
	}
</style>
